const ETANG_EQ_EXTERIEUR_RED = require('./ETANG_EQ_EXTERIEUR_RED.webp');
export default [ETANG_EQ_EXTERIEUR_RED];
